// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-p_fA","advertDetailContactGroup__header":"c-p_fB","advertDetailContactGroup__value":"c-p_fC"};